<div id="mention_table">
	<div class="tyalls-table-name mb-2">
		<h6 class="tyalls-table-heading">{{ panelHeading }}</h6>
	</div>
</div>

<div class="flex gap-2 flex-wrap pb-3">

	<div class="relative pr-2 pt-2">
		<div (click)="showCommentsView()" data-cy="show-comments-view-button" class="cursor-pointer button-height">
			<div class="flex justify-content-center">
				Comments
			</div>
			<p-badge data-cy="comment-count" [value]="comments.length.toString()" class="absolute top-0 right-0 pl-2"></p-badge>
		</div>
	</div>

	<div class="relative pr-2 pt-2">
		<div class="cursor-pointer button-height flex w-20">
			<div (click)="showSupportingFilesView()" data-cy="show-supporting-files-view-button" class="flex justify-content-center">
				Files
			</div>
			<app-dropdown-button (toggleDropdown)="toggleDropdown()" *ngIf="supportingFiles.length > 1"
													 [isVisible]="isDropdownVisible"></app-dropdown-button>
			<app-dropdown-menu (setCurrentSupportingFileFromDropdown)="setCurrentSupportingFileFromDropdown($event)"
												 [isVisible]="isDropdownVisible" [items]="supportingFiles"></app-dropdown-menu>
			<p-badge data-cy="supporting-files-count" [value]="supportingFiles.length.toString()" class="absolute top-0 right-0 pl-2"></p-badge>
		</div>
	</div>

	<div class="relative pr-2 pt-2">
		<div (click)="showDetailsView()" data-cy="show-details-view-button" class="flex justify-content-center cursor-pointer button-height">
			<div>Details</div>
		</div>
	</div>

	<div class="relative pr-2 pt-2" *ngIf="canSendBackToPreviousGroup">
		<div
			(click)="showAssignView()"
			data-cy="show-assign-view-button"
			class="flex justify-content-center cursor-pointer button-height"
		>
			<div>Send Back</div>
		</div>
	</div>

</div>

<div [hidden]="!commentsView" class="relative pt-2">
	<button data-cy="add-comment-button" (click)="onButtonRowClick('add_comment')" [disabled]="!hasPrimaryDocument"
					class="p-button-raised p-button-rounded h-8 absolute top-0 right-0" icon="pi pi-comment" pButton
					pRipple></button>
	<app-task-comments [comments]="comments"></app-task-comments>
</div>


<div [hidden]="!detailsView" class="pt-2 px-2"
>
	<p-panel *ngIf="currentTask.description" [collapsed]="true" [toggleable]="true" header="Instructions">
		<p>
			{{ currentTask.description }}
		</p>
	</p-panel>
	<div [class]="detailsView ? 'details-bg' : null" class="mt-3">
		<div *ngFor="let assignment of assignments">
			<div class="flex">
				<div>
					<div [class]="assignment.finishDateTime ? 'details-orange' : 'details-grey'"
							 class="details-icon flex flex-none align-items-center justify-content-center text-white">
						<i class="pi pi-check text-sm"></i>
					</div>
					<div [class]="assignment.finishDateTime ? 'details-border-orange' : 'details-border-grey'" class="mt-1"></div>
				</div>
				<div class="px-2 pb-2">
					<div [class]="assignment.finishDateTime ? 'details-card-orange' : 'details-card-grey'"
							 class="p-3 w-full text-sm font-bold mb-2">
						<p class="white-space-normal">Group: {{ assignment.workflowGroup }}</p>
					</div>
					<div class="xl:flex text-xs px-2 mb-1">
						<div *ngIf="assignment.finishDateTime" class="mb-2 mr-3">
							Reviewed by: <span class="font-bold">{{ assignment.assigneeDisplay }}</span>
						</div>
						<div *ngIf="assignment.finishDateTime">
							Date: <span class="font-bold">{{ assignment.finishDateTime | DatePropertyTimezone:true:true }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<div
	*ngIf="supportingFilesView && supportingFiles.length > 0 && currentSecondaryFile"
	class="relative"
>
	<app-pdf-file-panel
		#fileUploadForm
		(uploadFile)="({})"
		[containerId]="secondaryPdfContainer"
		[currentFile]="currentSecondaryFile"
		[currentTask]="currentTask"
		[hasPdfReport]="!!(currentSecondaryFile.documentId || currentSecondaryFile.storageId || currentSecondaryFile.data)"
		[isPrimary]="false"
		[showPanelPadding]="showPanelPadding"
	></app-pdf-file-panel>
</div>

<div [hidden]="!supportingFilesView">
	<h6 [hidden]="!supportingFilesView" class="title-text-supporting mr-3 line-height-3">Upload supporting files</h6>
	<p-fileUpload data-cy="supporting-file-upload" #subFileUploadForm (uploadHandler)="onUploadSupportDoc($event)" [customUpload]="true" [disabled]="!hasPrimaryDocument"
								[hidden]="!supportingFilesView" [multiple]="true" accept=".pdf, .jpg, .png, .doc, .docx, .xls, .xlsx, .csv"
								chooseLabel="Choose file" mode="basic">
		<ng-template pTemplate="toolbar"></ng-template>
		<ng-template pTemplate="content">
			<ul *ngIf="uploadedFiles.length">
				<li *ngFor="let uploadFile of uploadedFiles">
					{{ uploadFile.file.name }} - {{ uploadFile.file.size }} bytes
				</li>
			</ul>
		</ng-template>
	</p-fileUpload>
</div>

<div *ngIf="assignView && canSendBackToPreviousGroup" class="relative">
	<div class="mb-2 font-bold">Assign workflow to previous a group</div>

	<div *ngIf="isLoadingStages" class="p-text-secondary mb-2">
		Loading stages...
	</div>

	<div *ngIf="!isLoadingStages && filteredStages.length === 0" class="p-text-secondary mb-2">
		No stages available.
	</div>

	<div *ngIf="!isLoadingStages && filteredStages.length > 0" class="mb-3">
		<p-dropdown
			[(ngModel)]="selectedStage"
			[options]="filteredStages"
			optionLabel="groupName"
			dataKey="id"
			placeholder="Select a Task Stage"
			appendTo="body"
			[baseZIndex]="20000"
			[style]="{ width: '100%' }"
			(onChange)="onTaskStageSelected($event.value)"
		></p-dropdown>
	</div>

	<button
		pButton
		type="button"
		label="Assign"
		class="p-button"
		[disabled]="!isPhobos || !selectedStage || isAssigning"
		(click)="confirmAssignBack(); $event.stopPropagation()"
	></button>
</div>
